export default __webpack_public_path__ + "static/media/auditExt.1dcc6db7.svg";